<template>
    <div class="chat-container">
        <div class="sql" v-if="sql">
            {{ sql }}
        </div>
        <div class="sql-empty" v-if="!dbKey">
            <img src="@/assets/img/chatbot/chat/db-icon.svg" alt="message" />
            <span>Por favor puedes elegir una base de datos antes de conversar</span>
        </div>
        <div class="chat-box">
            <div class="chat-header">
                <div class="chat-header-left">
                    <button @click="toggleExpand">
                        <img src="@/assets/img/chatbot/chat/chat-border.svg" alt="message" />
                    </button>
                    <span>Conversación</span>
                </div>
                <button @click="toggleExpand">
                    <img width="18" src="@/assets/img/chatbot/hidden.svg" alt="hidden" />
                </button>
            </div>

            <div v-if="!dbKey" class="db-selection">
                <p class="db-title">Elige la base de datos</p>
                <div class="db-buttons">
                    <button @click="setDbKey('chinook')" :class="{ active: dbKey === 'chinook' }">Chinook</button>
                    <button @click="setDbKey('netflix')" :class="{ active: dbKey === 'netflix' }">Netflix</button>
                </div>
            </div>

            <ChatBox :dbKey="dbKey" @update:dbKey="setDbKey" :chatHistory="chatHistory" :newMessage="newMessage"
                @send="sendMessage" @update:newMessage="setNewMessage" type="db" />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import ChatBox from "@/components/Bot/ChatBox.vue";

export default {
    name: "ChatDB",
    components: { ChatBox },
    data() {
        return {
            sql: null,
            thinkingMessageIndex: null
        };
    },
    computed: {
        ...mapState(["chatHistory", "newMessage", "dbKey"]),
        ...mapGetters(["chatType"])
    },
    methods: {
        ...mapMutations({
            setDbKey: 'SET_DB_KEY',
            setNewMessage: 'UPDATE_MESSAGE'
        }),
        ...mapActions([
            'updateMessage',
            'addMessage',
            'resetChat',
            'changeChatType'
        ]),

        toggleExpand() {
            this.$router.push("/");
        },

        async sendMessage(question) {
            if (!question?.trim()) return;

            await this.addMessage({ from: "me", type: "text", text: question });
            await this.updateMessage("");
            await this.addMessage({ from: "bot", type: "text", text: "Pensando", thinking: true });

            this.thinkingMessageIndex = this.chatHistory.length - 1;

            try {
                const response = await this.$axios.post("https://api-qa.chelita.com.mx/db-agent/query", {
                    user_id: "1234",
                    question,
                    db_key: this.dbKey
                });

                this.sql = response.data.sql;

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1, {
                    from: "bot",
                    type: "html",
                    text: response.data.answer
                });
            } catch (error) {
                console.error("Error al enviar pregunta:", error);

                this.$store.state.chatHistory.splice(this.thinkingMessageIndex, 1, {
                    from: "bot",
                    type: "text",
                    text: "Ocurrió un error al procesar tu pregunta. Intenta nuevamente."
                });
            }

            this.thinkingMessageIndex = null;
        }
    }
};
</script>


<style scoped>
.db-selection {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 2rem 0;
    color: white;
    background-color: #061821;
    border-top: 1px solid #2a2b2e;
}

.db-title {
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 12px;
    font-weight: bold;
}

.db-buttons {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
}

.db-buttons button {
    padding: 10px 3rem;
    border: 1px solid #7a94b2;
    background: transparent;
    color: #7a94b2;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
}

.db-buttons button:hover {
    border-color: white;
    color: white;
}

.db-buttons button.active {
    border-color: #ffffff;
    color: #ffffff;
}

.chat-container {
    position: relative;
    height: 100vh;
    width: 100%;
}

.sql {
    color: white;
    display: flex;
    font-size: medium;
    font-weight: 700;
    flex: 1;
    height: 40vh;
    text-align: center;
    align-items: center;
    justify-content: center;
}

.sql-empty {
    background: linear-gradient(90deg, #6294BA, #0A2129);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: flex;
    flex-direction: column;
    font-size: small;
    flex: 1;
    height: 30vh;
    text-align: center;
    align-items: center;
    justify-content: end;
}

.chat-box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60vh;
    display: flex;
    flex-direction: column;
    background-color: #061821;
    overflow: hidden;
}


.chat-header {
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    padding: 1rem;
    background-color: #17181B;
    border-bottom: 1px solid #2a2b2e;
}

.chat-header-left {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    gap: 10px;
}

.chat-header button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.chat-header span {
    color: #ffffff;
    font-weight: bold;
}


@media (max-width: 768px) {
    .chat-header {
        background-color: #061821;
    }

    .db-buttons button {
        padding: 10px 2rem;
        width: 100%;
        max-width: 200px;
        text-align: center;
    }

    .sql {
        display: none;
    }

    .sql-empty {
        display: none;
    }

    .chat-container {
        display: flex;
        flex-direction: column;
        height: 100dvh;
        width: 100%;
        background-color: #061821;
    }

    .chat-box {
        flex: 1;
        height: 100dvh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

}
</style>